// ============================================================
// taskScopeCache.ts
// My Work's per-scope task list cache (mine / firm / unclaimed), keyed
// `${userId}:${permissionsVersion}:${scope}`. Lives in its own module (not
// TasksView) so clearAuth() can wipe it on logout (Batch C): otherwise a
// previous session's lists — possibly a firm-wide list the next session may
// no longer see — stayed in memory and could flash on the next login.
// ============================================================
import type { Task } from '../types/tasks.types'

export const scopeTaskCache = new Map<string, Task[]>()

export const clearTaskScopeCache = (): void => { scopeTaskCache.clear() }
